import { type PropsWithChildren } from 'react';
import { Redirect } from '@lingoda/router';
import { getFallbackUrl, shouldFallbackToDefaultLang } from './utils';

interface Props {
    routeLabel?: string;
}
export const LangValidationFallback = ({ children, routeLabel }: PropsWithChildren<Props>) => {
    const currentUrl = window.location.href;

    if (shouldFallbackToDefaultLang(currentUrl, routeLabel)) {
        const fallbackUrl = getFallbackUrl(currentUrl);

        if (fallbackUrl !== currentUrl) {
            return <Redirect to={fallbackUrl} />;
        }
    }

    return <>{children}</>;
};
